import {watchlistTypes} from "../../actions/Dashboard/Watchlist/actionsType";

export const initState = {
    isEmpty: false,
    shouldDelete: false,
    shouldRefetch: false,
    search: null,
    tempSearch: null,
    datatable: {
        selectedPlayers: [],
        expandedRows: [],
        currentPage: 1,
        pageSize: 10,
        sortField: null,
        sortOrder: null,
    },
};

const WatchlistReducer = (state = initState, action) => {
    switch (action.type) {
        case watchlistTypes.TOGGLE_SELECT_PLAYER: {
            const selectedPlayers = state.datatable.selectedPlayers;
            const exists = selectedPlayers.map(player => player.id).indexOf(action.player.id) !== -1;

            return Object.assign({}, state, {
                ...state,
                datatable: {
                    ...state.datatable,
                    selectedPlayers: exists ? selectedPlayers.filter(player => player.id !== action.player.id) : [...selectedPlayers, action.player]
                },
            });
        }

        // Pagination
        case watchlistTypes.SET_PAGINATION: {
            return Object.assign({}, state, {
                ...state,
                datatable: {
                    ...state.datatable,
                    ...action.pagination,
                },
            });
        }

        // Search
        case watchlistTypes.SET_SEARCH_VALUE: {
            return Object.assign({}, state, {
                ...state,
                search: action.search,
            });
        }
        case watchlistTypes.SET_TEMP_SEARCH_VALUE: {
            return Object.assign({}, state, {
                ...state,
                tempSearch: action.search,
            });
        }

        // Expand
        case watchlistTypes.SET_EXPAND_ROW: {
            const expandedRows = state.datatable.expandedRows;

            return Object.assign({}, state, {
                ...state,
                datatable: {
                    ...state.datatable,
                    expandedRows: action.isExpand ? [...expandedRows, action.row] :
                        expandedRows.filter(row => row.id !== action.row.id)
                },
            });
        }

        // Empty
        case watchlistTypes.SET_EMPTY: {
            return Object.assign({}, state, {
                ...state,
                isEmpty: action.isEmpty
            });
        }

        // REMOVE
        case watchlistTypes.REMOVE_SELECTED_PLAYERS: {
            return Object.assign({}, state, {
                ...state,
                shouldDelete: true,
            });
        }

        case watchlistTypes.CLEAR_SELECTIONS: {
            return Object.assign({}, state, {
                ...state,
                shouldDelete: false,
                datatable: {
                    ...state.datatable,
                    selectedPlayers: [],
                }
            });
        }

        case watchlistTypes.SET_REFETCH: {
            return Object.assign({}, state, {
                ...state,
                shouldRefetch: action.shouldRefetch,
            });
        }

        case watchlistTypes.SET_ORDER: {
            return Object.assign({}, state, {
                ...state,
                datatable: {
                    ...state.datatable,
                    sortField: action.field,
                    sortOrder: action.order,
                }
            });
        }

        default: {
            return state;
        }
    }
};

export default WatchlistReducer;
